import React, { useState } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { useLanguage } from '../../../context/LanguageContext';
import { languages } from '../../../constants/languages';
import { navigationItems } from '../../../constants/navigation';
import logo from '../../../logo-full.svg';
import './Header.css';

const Header = ({ scrolled, scrollToSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const { language, changeLanguage, t } = useLanguage();

  const handleScrollToSection = (id) => {
    scrollToSection(id);
    setIsMenuOpen(false);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <img src={logo} alt="First Capital Global Cambodia" className="h-16 w-auto" />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            {navigationItems.map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className={`capitalize font-medium transition-colors ${
                  scrolled ? 'text-gray-700 hover:text-brand-primary' : 'text-white hover:text-brand-light'
                }`}
              >
                {t(`nav.${item}`)}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-brand-primary text-white px-6 py-2 rounded-lg hover:bg-brand-dark transition-all shadow-lg"
            >
              {t('nav.getStarted')}
            </button>

            {/* Language Switcher */}
            <div className="language-switcher">
              <button
                onClick={() => setIsLangMenuOpen(!isLangMenuOpen)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${
                  scrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <Globe className="h-5 w-5" />
                <span className="text-2xl">
                  {languages.find(lang => lang.code === language)?.flag}
                </span>
              </button>

              {isLangMenuOpen && (
                <div className="language-dropdown">
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      onClick={() => {
                        changeLanguage(lang.code);
                        setIsLangMenuOpen(false);
                      }}
                      className={language === lang.code ? 'active' : ''}
                    >
                      <span className="text-3xl">{lang.flag}</span>
                      <span>{lang.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`md:hidden ${scrolled ? 'text-gray-900' : 'text-white'}`}
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 py-4 space-y-3">
            {navigationItems.map((item) => (
              <button
                key={item}
                onClick={() => handleScrollToSection(item)}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg capitalize"
              >
                {t(`nav.${item}`)}
              </button>
            ))}

            {/* Mobile Language Switcher */}
            <div className="pt-3 border-t mt-3">
              <p className="px-4 text-xs font-semibold text-gray-500 mb-2">Language</p>
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => {
                    changeLanguage(lang.code);
                    setIsMenuOpen(false);
                  }}
                  className={`block w-full text-left px-4 py-3 rounded-lg flex items-center gap-3 ${
                    language === lang.code ? 'bg-blue-50 text-brand-primary font-semibold' : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <span className="text-3xl">{lang.flag}</span>
                  <span className="text-base">{lang.name}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
